import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./assets/_js/components/eventBus.js